export default function LoginViaToken() {
  return null;
}
